module.exports = __webpack_public_path__ + "img/form-settings-search.e595df52.svg";